import didUpdate from 'webapp/modifiers/did-update';
import FormInputComponent from 'webapp/components/form/input';
import type { FormInputDecimalComponentArgs } from 'webapp/components/form/input-decimal';
import FormInputDecimalComponent from 'webapp/components/form/input-decimal';
import ScrollableTextComponent from 'webapp/components/scrollable-text';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

interface FormInputPercentComponentArgs extends FormInputDecimalComponentArgs {
	format?: string;
	tooltip?: { text: string };
}

export default class FormInputPercentComponent extends FormInputDecimalComponent<FormInputPercentComponentArgs> {
	get formattedPercentValue(): string | null {
		if (!this.args.format) {
			return null;
		}

		const value = +this.formattedValue || 0;
		let formattedQualiferPercentValue = value;

		if (this.args.format.includes('%')) {
			formattedQualiferPercentValue *= 100;
		}

		formattedQualiferPercentValue = Math.round(formattedQualiferPercentValue * 100) / 100; // format to 2 decimals

		return `${formattedQualiferPercentValue}%`;
	}
	<template>
		<div
			class="input-decimal {{this.themeClass}}"
			{{didUpdate this.forceUpdateOnValueChange @forceUpdateFromValue @value}}
		>

			<div class="input-group input-group--with-percentage">
				<FormInputComponent
					name={{this.name}}
					maxlength={{@maxLength}}
					@value={{this.formattedValue}}
					class={{@className}}
					@input={{this.change}}
					placeholder={{@placeholder}}
					disabled={{@isDisabled}}
					@hideFloatLabel={{true}}
					@loseFocusOnEnter={{true}}
					@focusIn={{this.focusIn}}
					@focusOut={{this.focusOut}}
					@insertNewline={{@insertNewline}}
					@theme={{@theme}}
					@size={{@size}}
					@onEmpty={{@onEmpty}}
				/>

				<div class="percent">
					<ScrollableTextComponent>
						{{this.formattedPercentValue}}
					</ScrollableTextComponent>
				</div>

			</div>

			{{#if @tooltip.text}}
				<ToolTipWithIconComponent @text={{@tooltip.text}} />
			{{/if}}

		</div>
	</template>
}
